module.exports = __webpack_public_path__ + "static/media/icon_syokumunaiyou.0efc8f20.svg";